export const SESSION_STATE = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  LOGIN_PENDING_ACTION: 'LOGIN_PENDING_ACTION',
  AUTHENTICATED: 'AUTHENTICATED',
  EXPIRED: 'EXPIRED',
  EXPIRED_LOGIN_PENDING_ACTION: 'EXPIRED_LOGIN_PENDING_ACTION',
  LOGGING_OUT: 'LOGGING_OUT',
} as const;
